import React, { useEffect, useState } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsFinalGreetingScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const [slovtext, setslovtext] = useState("");
    const [errorText, setErrorText] = useState("");

    const maxLength = 90;

    const paperStyle = {
        width: "250px",
        height: "50px",
        margin: "8px auto",
        backgroundImage: "url('https://cyberbox.trgu.ru/public/cardsgame/paper.png')",
        backgroundSize: "100% 100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "black",
        fontWeight: "bold",
        textAlign: "center",
        padding: "5px",
        boxSizing: "border-box",
    };

    const handleSend = () => {
        if (slovtext.trim().length < 15) {
            setErrorText("Смелее, напиши больше!");
            return;
        }

        props.sendMessage(`sendtoserver|slov\\addtext\\` + slovtext);
        setslovtext("");
        setErrorText("");
    };

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><i>От кого:</i></div>
            <div className="divtext_slov"><b>{props.TextString}</b></div>
            <br />

            <div className="divtext_slov"><i>Кому: ???</i></div>
            <br />

            <div style={paperStyle}>{props.TextString2}</div>
            <div style={paperStyle}>{props.TextString3}</div>
            <br />

            <textarea
                autoComplete="off"
                className="FormInput"
                style={{ width: "80%", height: "6em" }}
                placeholder="Поздравление"
                maxLength={maxLength}
                value={slovtext}
                onChange={(e) => {
                    setslovtext(e.target.value);
                    setErrorText("");
                }}
            />

            <br />

            <button type="button" onClick={handleSend}>
                Отправить
            </button>

            {errorText !== "" && (
                <div style={{ color: "red", marginTop: "10px" }}>
                    {errorText}
                </div>
            )}
        </div>
    );
};